/**
 * Auth0 Configuration
 *
 * This file exports the Auth0 configuration object.
 *
 * Required environment variables:
 * - VITE_AUTH0_DOMAIN: Your Auth0 domain (e.g., your-tenant.auth0.com)
 * - VITE_AUTH0_CLIENT_ID: Your Auth0 application client ID
 * - VITE_AUTH0_AUDIENCE: Your Auth0 API audience (optional, for API access)
 * - VITE_AUTH0_REDIRECT_URI: The callback URL after authentication (defaults to window.location.origin)
 *
 * To set these up:
 * 1. Create a .env file in the root of earlycore-frontend
 * 2. Add the variables above with your Auth0 credentials
 */

export const auth0Config = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN || '',
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID || '',
  authorizationParams: {
    redirect_uri: import.meta.env.VITE_AUTH0_REDIRECT_URI || window.location.origin,
    audience: import.meta.env.VITE_AUTH0_AUDIENCE || undefined,
  },
  // Use Auth0's hosted login page and enable refresh tokens
  useRefreshTokens: true,
  cacheLocation: 'localstorage' as const,
};

// Validate that required environment variables are set
if (!auth0Config.domain || !auth0Config.clientId) {
  console.warn(
    'Auth0 configuration is missing. Please set VITE_AUTH0_DOMAIN and VITE_AUTH0_CLIENT_ID in your .env file.'
  );
}
